<div class="documents-loading-container">
  <div class="card">
    <p class="header">We're loading your documents</p>
    <p class="body">
      Please wait a few minutes for your documents to finish downloading.
    </p>
    <app-progress-bar class="progress-bar" [mode]="'indeterminate'"></app-progress-bar>
  </div>
</div>
